export const SourceTypeIds = {
  Altus: 'altus',
  AltusLists: 'altuslists',
  Asana: 'asana',
  Salesforce: 'salesforce',
  Cds: 'cds',
  ClickUp: 'clickup',
  GoogleCalendar: 'googlecalendar',
  GoogleDrive: 'googledrive',
  GoogleTasks: 'googletasks',
  Monday: 'monday',
  Confluence: 'confluence',
  Gmail: 'gmail',
  GitHub: 'github',
  GitLab: 'gitlab',
  Jira: 'jira',
  MSProject4TW: 'msproject4tw',
  MicrosoftPlanner: 'microsoftplanner',
  OneNote: 'onenote',
  Notion: 'notion',
  SharePoint: 'sharepoint',
  Slack: 'slack',
  Todoist: 'todoist',
  OutlookMail: 'outlookmail',
  OutlookTasks: 'outlooktasks',
  OutlookCalendar: 'outlookcalendar',
  Trello: 'trello',
  Vsts: 'vsts',
  Zendesk: 'zendesk',
} as const;

export type SourceTypeId = (typeof SourceTypeIds)[keyof typeof SourceTypeIds];

const sourceTypeIdSet = new Set<SourceTypeId>(Object.values(SourceTypeIds));

export const toSourceTypeId = (sourceTypeId: string): SourceTypeId | null => {
  const normalizedSourceTypeId = sourceTypeId.trim().toLowerCase();

  if (sourceTypeIdSet.has(normalizedSourceTypeId as SourceTypeId)) {
    return normalizedSourceTypeId as SourceTypeId;
  }

  return null;
};
